<template>
  <el-dialog :title="mytitle" :visible.sync="dialogFormVisible" custom-class="list-dialog" center :append-to-body="true"
             :close-on-click-modal="false"
  >
    <div class="search-content write-order">
      <el-row>
        <el-row>
          <el-col :span="24" class="toobar">
            <el-col :span="5">
              <AutoCustomer ref="autocustomer" @handleSelect="select" :splitByAddress="true"></AutoCustomer>
            </el-col>
            <!--<div style="float: right;width: 1411px;">-->
            <el-col :span="18">
              <el-select v-model="cangkucode" @change="changeCangKu"
                         v-if="deliveryaddress==''?false:true"
                         style="width: 130px;display: block;margin: auto;float: left;margin-left: 30px;">
                <el-option v-for="item in jxcstoreData" :key="item.cangkucode"
                           :label="item.cangkuname"
                           :value="item.cangkucode">
                </el-option>
              </el-select>
              <CommonTree ref="treeSeed" :defineDataSource="true" @bindData="bindData"
                          :isShowCheckBox="false" :treeWidth="550"
                          style="width: 200px;display: block;margin: auto;float: left;margin-left: 30px;"
                          :onlyShowGroupType="false" :needTopNode="false" :onlySelectChild="true"
                          :treeHeight="500" :searchText="seedname"
                          @check="checktree1"></CommonTree>
              <el-input v-model="tracknum" ref="tracknum" placeholder="请填写供应商单号" @change="tracknumsubmit" clearable
                        v-if="mytitle!='门店下单'"
                        onfocus="this.select()"
                        style="width: 160px"></el-input>
              <el-input v-model="logisticstracknum" ref="logisticstracknum" placeholder="请填写跟踪单号" clearable
                        v-if="mytitle!='门店下单'"
                        @change="logisticstracknumsubmit"
                        onfocus="this.select()"
                        style="width: 160px"></el-input>
              <el-button type="success" @click.stop.prevent="showGoodDetailSel()">选择</el-button>
              <el-button type="warning" @click.stop.prevent="jinjiatuihuo()">退货申请</el-button>
            </el-col>
            <!--</div>-->
          </el-col>
        </el-row>
        <el-row>
          <div style="float: left;margin-top: 8px;font-size: larger;margin-left: 5px"
               v-if="deliveryaddress==''?false:true"> 门店：<span>{{this.deptname}}</span>&nbsp;&nbsp;收获地址：<span>{{this.deliveryaddress}}</span>
          </div>
        </el-row>
      </el-row>
      <el-row>

      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <iframe width="100%" scrolling="Auto" id="iframe" ref="iframe"
                  :height="tableHeight(130)" frameborder="0" name="writeorder1" @click="isshow"></iframe>
        </el-col>
      </el-row>
    </div>
    <BatchBuyFormProperties ref="batchBuyFormProperties" @afterSelectCode="afterSelectCode"></BatchBuyFormProperties>
    <HsCstagreementList ref="HsCstagreementList"></HsCstagreementList>
  </el-dialog>


</template>

<script>
  import BatchBuyFormProperties from '../buyagreement/BatchBuyFormProperties'
  import {getListData, deleteData, getpinyinlistData} from '@/api/set/externaldept';
  import {independentDept} from '@/api/set/dept';
  import {simulationLogin} from '@/api/login';
  import {cusandptbyind} from '@/api/set/jxcstore';
  import HsCstagreementList from './HsCstagreementList';
  import {getGoodsTree, getListfixcilumn} from '@/api/set/jxcgooddetail';

  export default {

    name: 'WriteFrameReturnOrder',
    data() {
      return {
        msg: 'Welcome to Your Vue.js App',
        dialogFormVisible: false,
        searchdata: "",
        myunitgroup: this.unitgroup,
        mytitle: this.title,
        loading: true,
        servedserial: "",
        idd: [],
        tableData: [],
        pinyinData: [],
        coupon: '',
        province: '',//省
        city: '',//市
        county: '',//县
        couponServedserial: '',//独立核算
        deliveryaddress: '',//收货地址
        deptname: '',
        loginName: '',
        customerserial: '',
        restaurants: [],
        timeout: null,
        elinkman: '',
        elinkmantel: '',
        canshowgoodsel: true,//解决清空事件与click的冲突问题
        seedcode: '',
        seedname: '',
        jxcstoreData: [],//仓库数组
        cangkucode: '',//选中的仓库
        cangkuname: '',
        roletype: '',//岗位类型
        tracknum: '',//供应商单号
        logisticstracknum: '',//跟踪单号
        seedcodeData: [],//选择类别后的商品
        totalnumber: 0,//总数量
        btnupdatevisible: false,//防止重复提交
        settingmenthod: '',//付款方式
        arr: [],
        thiswindow: null,
      }
    },
    props: {
      unitgroup: {
        default: 1
      },
      title: {
        default: "客户信息"
      },
      parentcustomerserial: {//上级客户编码
        default: ""
      },
      filterbyservedserial: {//根据当前登录人所属的加工中心过滤数据
        default: false
      },
      storeInfo: {
        default: ""
      }
    },
    methods: {
      jinjiatuihuo() {
        if (!this.customerserial) {
          this.$message.error("请先选择门店");
          return
        }
        window.open("//" + window.location.host + "/H5/html/DaiFaHuo/dingDan/dingDan_main.html", 'writeorder1', false)
      },
      //ifame点击删除后调用的方法
      del(data) {
        if (data) {
          this.tableData = []
          this.tableData = JSON.parse(JSON.stringify(data))

        }
      },

      //显示商品选择页面
      showGoodDetailSel() {
        if (!this.customerserial) {
          this.$message.error("请先选择门店");
          return
        }
        if (this.seedcodeData.length == 0) {
          this.$message.error("请先选择商品分类");
          return
        }
        for (let i in this.seedcodeData) {
          this.seedcodeData[i].totalnumber = 0
        }
        //参数  false 不显示库存，seedcode分类，cangkucode 仓库，seedcodeData 分类下的商品

        window.open("//" + window.location.host + "/#/app/emptyVue" , 'writeorder1',false)
        this.$refs.batchBuyFormProperties.initData(true, this.seedcode, this.cangkucode, this.seedcodeData)
      },
      //删除明细
      handleDelete(index, row) {
        this.tableData.splice(index, 1)
      },
      //iframe 子类调用的方法（退货成功后用）
      isshow() {
        this.dialogFormVisible = false
        this.$emit("bindGrid")//刷新页面
      },
      tracknumsubmit() {
        localStorage.setItem('tracknum', this.tracknum.trim());
        this.$refs.logisticstracknum.focus()
      },
      logisticstracknumsubmit() {
        localStorage.setItem('logisticstracknum', this.logisticstracknum.trim());
      },
      //选择类别后执行的方法
      checktree1(guids, names, arr) {
        if (!this.customerserial) {
          this.$message.error("请先选择门店");
          return
        }
        this.seedcode = guids
        this.seedname = names
        this.seedcodeData = []
        getListfixcilumn({
          categorycode: this.seedcode,
          nostock: 1,
          iskucun: 1,
          cangkucode: this.cangkucode,
        }).then(response => {
          var obj = response.data.obj.rows
          if (obj.length > 0) {
            for (let i in obj) {
              if (obj[i].filltemplate == 40) {
                obj[i].totalnumber = 0
                this.seedcodeData.push(obj[i])
              }
            }
            //参数  false 不显示库存，seedcode分类，cangkucode 仓库，seedcodeData 分类下的商品

            window.open("http://" + window.location.host + "/#/app/emptyVue" , 'writeorder1',false)
            this.$refs.batchBuyFormProperties.initData(true, this.seedcode, this.cangkucode, this.seedcodeData);
          } else {
            this.$message({
              message: '该系列没有备货商品',
              type: 'warning'
            })
            return
          }
        }).catch((error) => {
          console.log(error)
        });

      },
      //选择商品之后执行
      afterSelectCode(arr) {
        //console.log(arr)
        let count = 0;//记录当前订单是否需要弹出提示
        for (let i in arr) {
          let biaoji = 0
          for (let j in this.tableData) {
            //判读该商品是否属于
            if ((!this.tableData[j].seedcode && arr[i].categorycode.startsWith(this.tableData[j].categorycode)) || (this.tableData[j].seedcode && this.tableData[j].seedcode == arr[i].seedcode
            )) {
              biaoji = 1
              count++;
              break
            }
          }
          if (biaoji == 0) {
            this.tableData.push({
              categoryname: arr[i].lname,
              seedcode: arr[i].seedcode,
              seedname: arr[i].seedname,
              categorycode: arr[i].categorycode,
              totalnumber: arr[i].totalnumber,
              formproperty: arr[i].formproperty,
              onlycode: '',
              barcodes: [],
              barcodesnum: 0,
            })
          }
        }
        //console.log(JSON.stringify(this.tableData))
        localStorage.setItem('tableData', JSON.stringify(this.tableData));
        this.openURL = 'HsTuiHuoJingJiaApp'
        //console.log("http://" + window.location.host + "/#/app/" + this.openURL);
        window.open("http://" + window.location.host + "/#/app/" + this.openURL, 'writeorder1',false)
        if (count > 0) {
          this.$message({
            message: "商品已存在，或者属于已选择类别下的商品",
            type: 'info'
          })
        }

      },
      bindData() {
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({onlyShowGroupType: true, onlyShowEnabledGroupType: true})
        })

      },
      //刷新按钮
      refreshBtn() {
        this.btnupdatevisible = false
      },
      //远程搜索
      loadAll() {
        for (let i = 0; i < this.pinyinData.length; i++) {
          this.pinyinData[i].value = this.pinyinData[i].fpinyin
        }
      },
      //远程搜索
      querySearchAsync(queryString, cb) {
        var results = this.pinyinData;
        if (queryString.length > 3) {
          clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            cb(results);
          }, 300 * Math.random());
        }
      },
      //远程搜索
      handleSelect(item) {
        if (!item.unitguid) {
          this.$refs.hide1.focus()
          this.bindGrid()
        } else {
          this.searchdata = item.deptname + "(" + item.deliveryaddress + ")"
          //处理选中之后的地址session问题
          this.select(item);
        }

      },

      //客户地址
      select(customerserial, customername, row) {
        this.deliveryaddress = row.deliveryaddress
        this.elinkman = row.linkman
        this.elinkmantel = row.linkmantel
        this.deptname = row.deptname
        this.customerserial = row.customerserial
        var settingmenthods = row.settingmenthod.split(',');
        for (let i = 0; i < settingmenthods.length; i++) {
          if (settingmenthods[i] == '全额现结') {
            settingmenthods[i] = 100
          } else if (settingmenthods[i] == '月结') {
            settingmenthods[i] = 200
          }
          if (this.settingmenthod) {
            this.settingmenthod = this.settingmenthod + ',' + settingmenthods[i]
          } else {
            this.settingmenthod = settingmenthods[i] + ''
          }
        }
        //客户信息
        simulationLogin({loginName: this.loginName, customerserial: this.customerserial}).then(response => {
          if (response.data.code == 0) {
            this.jxcstoreData.forEach(o => {
              if (o.cangkucode == this.cangkucode) {
                this.cangkuname = o.cangkuname
              }
            })
            localStorage.setItem('hpweb_token', response.data.token); //兼容vue端的相关页面
            localStorage.setItem('keFTtoken', response.data.token); //token
            localStorage.setItem('keFuInfoModel', JSON.stringify(response.data.obj)); //用户信息
            localStorage.setItem('domain', window.location.host);
            localStorage.setItem('deliveryaddress', this.deliveryaddress);
            localStorage.setItem('elinkman', this.elinkman);
            localStorage.setItem('elinkmantel', this.elinkmantel);
            localStorage.setItem('cangkucode', this.cangkucode);
            localStorage.setItem('cangkuname', this.cangkuname);
            localStorage.setItem('roletype', this.roletype);
            localStorage.setItem('settingmenthod', this.settingmenthod);
            localStorage.setItem('title', this.mytitle);
            if (this.mytitle == '门店下单') {
              //前台缓存使用
              if (localStorage.getItem('keFTtoken')) {
                localStorage.setItem('$state', JSON.stringify({'token': localStorage.getItem('keFTtoken')}));
                localStorage.setItem('keFuInfo', 'keFuInfo'); //作为判断是客服的操作，登录时会删除这个状态
              }
              if (localStorage.getItem('keFuInfoModel')) {
                var kuFuInfoModel = JSON.parse(localStorage.getItem('keFuInfoModel'));
                localStorage.removeItem('keFuInfoModel');
                window.localStorage.setItem('$xh_user', JSON.stringify({
                  'uguid': kuFuInfoModel.uguid,
                  'linkmantel': kuFuInfoModel.memberDO.linkmantel,
                  'uname': kuFuInfoModel.uname,
                  'md5password': '',
                  'TenantID': ''
                }));
                localStorage.setItem('deptname', kuFuInfoModel.tenantname); //缓存公司名称
                localStorage.setItem('uname', kuFuInfoModel.uname); //我的页面名称
                localStorage.setItem('mobile', kuFuInfoModel.memberDO.linkmantel); //我的页面名称kuFuInfoModel.mobile
                localStorage.setItem('status', kuFuInfoModel.status); //缓存账号类型判断是否能查看余额
                localStorage.setItem('uguid', kuFuInfoModel.uguid); //用于获取头像
                localStorage.setItem('tenantid', kuFuInfoModel.tenantid); //用于获取头像
                localStorage.setItem('linkmantel', kuFuInfoModel.memberDO.linkmantel); //与登录账号比较，是否显示子账号
                localStorage.setItem('servername', kuFuInfoModel.memberDO.servedname); //servername，服务商地址
                localStorage.setItem('currentlevel', "2"); //是否能支付 为2就是能支付
                localStorage.setItem('isRight', true);
                if (kuFuInfoModel.memberDO != null) {
                  window.localStorage.setItem('MUnitguid', kuFuInfoModel.memberDO.unitguid) //缓存Unitguid获取开票信息
                }
              }

            }

            this.afterSelectCode([])
          } else {
            this.$message({
              type: 'warning',
              duration: 1500,
              message: response.data.msg
            });
          }
        })
      },
      bindGrid() {
        this.pinyinData = []
        if (this.searchdata.length < 4) {
          this.$message({
            message: '至少四位',
            type: 'warning',
            duration: '1500',
          })
          return
        }

        getpinyinlistData({
          search: this.searchdata.toLocaleLowerCase(),
          unitgroup: this.myunitgroup,
          servedserial: this.servedserial,
          parentcustomerserial: this.parentcustomerserial,
          coupon: this.coupon,
          province: this.province,//省
          city: this.city,//市
          county: this.county,//县
          couponServedserial: this.couponServedserial,//独立核算
        }).then(response => {
          this.pinyinData = response.data.obj
          this.loadAll();
          this.$refs.droplist1.focus()
        }).catch((error) => {
          console.log(error)
        });
      },

      changeCangKu() {
        localStorage.setItem('cangkucode', this.cangkucode);
        this.jxcstoreData.forEach(o => {
          if (o.cangkucode == this.cangkucode) {
            this.cangkuname = o.cangkuname
          }
        })
        localStorage.setItem('cangkuname', this.cangkuname);
        try {
          window.writeorder.window.refreshErWeiTable()
        } catch (ee) {
        }
      },
      showdailog(groupguid) {
        this.$refs.HsCstagreementList.bindGrid(groupguid)
      },
      inittableData() {
        this.tableData = []
      },
      show(unitgroup, title, roletype) {
        if (this.$refs.autocustomer) {
          this.$refs.autocustomer.clearContent();
        }
        this.totalnumber = 0
        this.seedcodeData = []
        this.seedname = ''
        this.searchdata = ''//选中的门店
        this.deliveryaddress = ''//收货地址
        this.restaurants = []
        this.pinyinData = []
        this.coupon = ''
        this.province = ''//省
        this.city = ''//市
        this.county = ''//县
        this.couponServedserial = ''//独立核算
        this.roletype = ''
        this.logisticstracknum = ''
        this.tracknum = ''
        this.tableData = []
        if (unitgroup) {
          this.myunitgroup = unitgroup
        }
        if (title) {
          this.mytitle = title
        } else {
          this.mytitle = '镜架退货单'
        }
        if (roletype) {
          this.roletype = roletype
        }
        this.dialogFormVisible = true
        if (this.storeInfo) {
          this.coupon = this.storeInfo.coupon
          this.province = this.storeInfo.province//省
          this.city = this.storeInfo.city//市
          this.county = this.storeInfo.county//县
          this.couponServedserial = this.storeInfo.independentserial//独立核算
        }
        this.cusandptbyind();

      },
      cusandptbyind() {
        //根据登录人过滤仓库
        cusandptbyind({}).then(response => {
          this.jxcstoreData = response.data.obj
          //默认仓库
          if (this.userInfoModel.cangku) {
            let temp1 = this.userInfoModel.cangku.split(";")
            biaoji:
              for (let i in temp1) {
                for (let j in  this.jxcstoreData) {
                  if (temp1[i] == this.jxcstoreData[j].cangkucode) {
                    this.cangkucode = temp1[i]
                    break biaoji;
                  }
                }
              }

          } else {
            this.cangkucode = this.jxcstoreData[0].cangkucode
          }
        })

      },

    },
    mounted() {
      window.showdailogjinjia = (groupguid) => {
        this.showdailog(groupguid)
      }
      window.inittableData = () => {
        this.inittableData()
      }

      //将方法设置成全局方法，用来子页面调用
      window['del'] = (data) => {
        this.del(data)
      }
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      this.servedserial = this.userInfoModel.independentserial;
      //默认值
      if (!this.userInfoModel.independentserial) {
        independentDept().then(response => {
          this.idd = response.data.obj
          if (this.userInfoModel.independentserial == "") {
            this.idd.unshift({serialnum: "all", dname: "全部"})
            this.servedserial = 'all';
          }

        })
      }
    },
    components: {
      BatchBuyFormProperties,
      HsCstagreementList
    }

  }


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  /*.el-table td, .el-table div, .el-table .cell {*/
  /*line-height: 23px;*/
  /*padding: 0px;*/
  /*color: red;*/
  /*}*/

  .name {
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .addr {
    font-size: 12px;
    color: #b4b4b4;
  }


</style>




// WEBPACK FOOTER //
// src/components/testorder/cstagreement/WriteFrameReturnOrder.vue